import React, { useEffect } from 'react'
import { __constants, __snackBarText, __snackBarSeverity } from '../../constants';
import { Button, Drawer } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/system';
import moment from 'moment';
import { updateHelpSupportStatus } from '../../Controllers/Help&Support';
const anchor = "right"; //DIRECTION FRO WHERE DRAWER WILL OPEN
const APP_URL = process.env.REACT_APP_SERVER_URL

export default function SupportDetail({ open, handleClose, data, cb,index }) {

    const handleStatus = async (status) => {
            const res = await updateHelpSupportStatus(data._id, { status })
            if (res.data.status === 200) {
                cb(status,data.createdAt,index)
            } 
    }

    return (
        <Drawer
            anchor={anchor}
            open={open}
            onClose={handleClose}
            sx={{ height: '100vh' }}
        >
            <Container>
                <Header>
                    <div>
                        <h4>Help & Support</h4>
                        <h5 style={{ margin: '5px 0' }}>{data.supportNo}</h5>
                    </div>
                    <CloseIcon className='pointer' onClick={handleClose} />
                </Header>
                <Body>
                    <div className='body'>{data?.description}</div>
                    {data?.status !== "Resolved" && <Button color='success' variant="outlined" size='small' onClick={() => handleStatus("Resolved")}>Mark as Resolved</Button>}
                </Body>
            </Container>
        </Drawer>
    )
}

const Container = styled("div")`
height: 100vh;
overflow:auto;
width: 30vw;
padding: 1rem;
.title{
color: var(--nona-theme-color);
font-size: 90%;
}
.divider-gap{
margin: 0.5rem 0;
}
`;

const Header = styled("div")`
width: 100%;
display: flex;
justify-content: space-between;
align-items: center;
h4{
font-weight: 900;
font-size: 120%;
}
position:sticky;
top:0;
background-color:white;
padding-bottom: 0.7rem;
border-bottom: 1px solid var(--card-border);
`;

const Body = styled("div")`
  margin-top: 1rem;
  padding:5px;
  font-size:14px;
  .heading{
    font-size:16px;
    margin: 10px 0;
  }
  .body{
    margin:10px 0;
  }
//   box-shadow : 0 0 4px 4px whitesmoke;
  border-radius:10px;
`;





